export const SectionHeading = ({ index, kicker, title, subtitle }) => {
    return (
        <div className="mb-12 max-w-3xl md:mb-16">
            <div className="mb-4 flex items-center gap-3">
                {index ? (
                    <span className="font-mono text-xs tracking-[0.2em] text-ink-cyan">
                        {index}
                    </span>
                ) : null}
                <span className="h-px w-10 bg-[var(--ink-border-strong)]" />
                <span className="font-mono text-xs uppercase tracking-[0.25em] text-[var(--ink-text-secondary)]">
                    {kicker}
                </span>
            </div>
            <h2 className="text-3xl font-medium tracking-tight text-[var(--ink-text-primary)] sm:text-4xl lg:text-5xl">
                {title}
            </h2>
            {subtitle ? (
                <p className="mt-4 text-base leading-relaxed text-[var(--ink-text-secondary)] md:text-lg">
                    {subtitle}
                </p>
            ) : null}
        </div>
    );
};

export default SectionHeading;
